import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, MessageCircle, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ConsultationBanner() {
  const navigate = useNavigate();

  return (
    <Card className="bg-gradient-to-r from-grandpal-green to-grandpal-green-dark text-white mb-6">
      <CardContent className="p-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
              <MessageCircle className="h-5 w-5" />
              <h3 className="text-xl font-bold">Need Expert Guidance?</h3>
            </div>
            <p className="text-grandpal-green-lighter mb-4">
              Book a consultation with our verified care placement experts. Get personalized advice 
              on Fair Deal applications, nursing home selection, and placement strategies.
            </p>
            <div className="flex items-center justify-center md:justify-start gap-4 text-sm">
              <div className="flex items-center gap-1">
                <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                <span>4.9/5 rating</span>
              </div>
              <div className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                <span>Available today</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button 
              variant="secondary"
              className="bg-white text-grandpal-green hover:bg-gray-50"
              onClick={() => navigate('/consultations')}
            >
              View Experts
            </Button>
            <Button 
              className="bg-grandpal-green-dark hover:bg-grandpal-green-dark/90 text-white border-2 border-white"
              onClick={() => navigate('/consultations')}
            >
              Book Consultation
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}